import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const fHeader = `
  font-family: inherit;
  font-size: 2.3rem;
  line-height: 1;
  letter-spacing: -0.02em;
`;

export const fHeaderSm = `
  font-family: inherit;
  font-size: 1.95rem;
  line-height: 1.17;
  letter-spacing: -0.02em;
`;

export const fBody = `
  font-family: inherit;
  font-size: 1.8rem;
  line-height: 1.17;
  letter-spacing: -0.02em;
`;

export const fBodySm = `
  font-family: inherit;
  font-size: 1.5rem;
  line-height: 1.17;
  letter-spacing: -0.02em;
`;

function fontFaceGenerator(fontFamily, src, style = "normal") {
  return `
  @font-face {
    font-family: '${fontFamily}';
    src: ${src};
    font-weight: 400;
    font-style: ${style};
  }
  `;
}

export const fontDefinitions = `
  ${fontFaceGenerator(
    "GT-America",
    "url('/assets/fonts/gt-america/GT-America-Standard-Light.ttf') format('truetype')"
  )}
  ${fontFaceGenerator(
    "GT-America",
    "url('/assets/fonts/gt-america/GT-America-Standard-Light-Italic.ttf') format('truetype')",
    "italic"
  )}
`;

export const cPlaceholder = `rgb(250, 250, 250)`;

export default createGlobalStyle`
  ${reset}

  ${fontDefinitions}
  
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    font-family: "GT-America", serif;
    font-size: 62.50%;
    @media (max-width: 767px) {
      font-size: 56%;
    }

    &:after {
      content: attr(data-font);
      position: fixed;
      top: 5px;
      left: 5px;
      text-transform: uppercase;
      font-family: monospace;
      font-size: 12px;
      opacity: 0.25;
    }
  }

  body {
    ${fBody};
    background: white;
    color: black;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
